import React from 'react';
import { CloseButton, Col, Row } from 'react-bootstrap';
import { forwardRef } from 'react';

const TitleBar = forwardRef(({title, close, openLayerHandler}, ref) => {

  return (
    <div className={'content-container-title p-3'} ref={ref}>
      <Row>
        <Col>
          <h6 className={'d-inline text-white fw-bold'}>{title}</h6>
        </Col>
        {close ?
          <Col className={"text-end"}>
            <CloseButton
              variant='white'
              className={"close-button"}
              onClick={openLayerHandler ?
                () => {
                  openLayerHandler();
                }
                : ''}>
            </CloseButton>
          </Col>
          : ''}
      </Row>
    </div>
  );
});

export default TitleBar;
